import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Jobs from "./components/Jobs/Jobs";
import Navigation from "./components/Navigation/Navigation";
import { useScrollToHash } from "./hooks/useScrollToHash";
import Category from "./pages/Category";
import Home from "./pages/Home";
import Section from "./pages/Section";

function AppContent() {
  useScrollToHash();

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/section/:slug" element={<Section />} />
        <Route path="/jobs" element={<Jobs />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
